export const checkRequirements = password => {
  return {
    lower: /[a-z]/.test(password),
    upper: /[A-Z]/.test(password),
    number: /[0-9]/.test(password),
    special: /[!@#\$%\^\&*\)\(+=._-]/.test(password),
    length: password.length >= 10,
  };
};
